// extracted by mini-css-extract-plugin
module.exports = {"row":"TableRow-module__row--9s1rA","actionable":"TableRow-module__actionable--2ItE5"};